<template>
  <div class="pg-main-layout">
    <div class="pg-main-layout__content">
      <div class="content__page">
        <component
          v-if="subLayoutData"
          :is="getSubLayoutComponent"
          :layoutProps="getSubLayoutProps"
          :subLayoutData="getChildLayoutData"
        >
          <slot></slot>
        </component>
        <slot v-else></slot>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import BlankLayout from "@/layouts/BlankLayout.vue"
import Footer from "../components/footer/Footer"
export default {
  components: {
    Footer,
  },
  props: {
    layoutProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
    subLayoutData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    getSubLayoutComponent () {
      return this.$_.get(this.subLayoutData, "component") || BlankLayout
    },
    getSubLayoutProps () {
      return this.$_.get(this.subLayoutData, "props")
    },
    getChildLayoutData () {
      return this.$_.get(this.subLayoutData, "child")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_variables.scss";
@import "@/assets/style/_mixins.scss";

$top-navbar-height: 5.5rem;
$side-navbar-width: 23rem;

.pg-main-layout {
  background-color: $gray;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .pg-main-layout__navbar {
    position: relative;

    .top-navbar {
      width: 100%;
      height: $top-navbar-height;
    }

    .side-navbar {
      position: absolute;
      top: $top-navbar-height;
      left: 0;
      width: $side-navbar-width;
      height: calc(100% - #{$top-navbar-height});
    }

    + .pg-main-layout__content {
      position: absolute;
      top: $top-navbar-height;
      left: $side-navbar-width;
      width: calc(100% - #{$side-navbar-width});
      height: calc(100% - #{$top-navbar-height});
    }
  }

  .pg-main-layout__content {
    display: flex;
    flex-direction: column;
    // overflow-y: auto;
    flex: 1 1 auto;

    .content__page {
      flex: 1 1 auto;
    }

    .content__footer {
      flex: 0 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/FooterLayout.vue